import { useEffect, useState } from "react";
import api from "@/lib/api";

export const SHOP_DEFAULTS = {
  phone: "",
  whatsapp: "",
  email: "",
  address: "",
  hours: "",
  wave_number: "",
  orange_money_number: "",
  instagram: "",
  facebook: "",
  tiktok: "",
};

export const useShop = () => {
  const [shop, setShop] = useState(() => {
    try {
      return { ...SHOP_DEFAULTS, ...JSON.parse(localStorage.getItem("sk_shop")) };
    } catch {
      return SHOP_DEFAULTS;
    }
  });

  useEffect(() => {
    api
      .get("/settings/shop")
      .then((r) => {
        setShop({ ...SHOP_DEFAULTS, ...r.data });
        localStorage.setItem("sk_shop", JSON.stringify(r.data));
      })
      .catch(() => {});
  }, []);

  return shop;
};
